import Marketing from "../../views/modules/marketing/Marketing";
import DocumentList from "@/views/modules/marketing/documents/DocumentList.vue";
import KPI from "@/views/modules/marketing/KPI.vue";

import layouts from "../../layout";

export default {
  path: "/marketing",
  name: "marketing",
  component: Marketing,
  meta: {
    auth: true
  },
  redirect: {
    name: "marketing-document"
  },
  children: [
    {
      path: "documents",
      name: "marketing-document",
      component: DocumentList,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Documents",
        title_i18n: "marketing.marketing-document",
        tags: ["marketing", "documents"],
        index: true
      }
    },
    {
      path: "kpi",
      name: "marketing-kpi",
      component: KPI,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "KPI",
        tags: ["marketing", "kpi"],
        index: true
      }
    }
  ]
};
